/**
 * Sprat iz adrese i predlog „dva čoveka" — isto pravilo kao na serveru
 * (`Sprat.cs`). Analiza 2.0 (G5), 14.10.2026: sprat iz „49/14/04" se bacao,
 * pa je operater kucao ono što na otpremnici već piše.
 */

export const NAJVISI_SPRAT = 30;
export const DVA_COVEKA_OD_SPRATA = 2;

/** „Njegoševa 49/14/04" → 4. Samo zapis kuća/stan/sprat, sva tri broja. */
export function spratIzAdrese(adresa: string | null | undefined): number | null {
  if (!adresa) return null;
  const m = /(\d+)\s*\/\s*(\d+)\s*\/\s*(\d+)\s*$/.exec(adresa.trim());
  if (!m) return null;
  const sprat = Number(m[3]);
  return sprat <= NAJVISI_SPRAT ? sprat : null;
}

/** Od drugog sprata bez lifta (ili kad se za lift ne zna) — predlog, čovek odlučuje. */
export function dvaCoveka(sprat: number | null, lift: boolean | null): boolean {
  return sprat !== null && sprat >= DVA_COVEKA_OD_SPRATA && lift !== true;
}
